import ProjetoRequest from "@/requests/ProjetoRequest";
import LogicaIntervencaoRequest from "@/requests/LogicaIntervencaoRequest";
import IndicadorRequest from "@/requests/IndicadorRequest";
import UsuarioRequest from "@/requests/UsuarioRequest";
import StorageRequest from "@/requests/StorageRequest"
import MonitoramentoRequest from "@/requests/MonitoramentoRequest"
import LancamentoRequest from "@/requests/LancamentoRequest"
import FormularioRequest from "@/requests/FormularioRequest"
import OrganizacaoRequest from "@/requests/OrganizacaoRequest"
import PrestacaoContaRequest from "@/requests/PrestacaoContaRequest"
import PessoaAlcancadaRequest from "@/requests/PessoaAlcancadaRequest"

const requests = {
    usuario: UsuarioRequest,
    projeto: ProjetoRequest,
    logicaIntervencao: LogicaIntervencaoRequest,
    indicador: IndicadorRequest,
    storage: StorageRequest,
    monitoramento: MonitoramentoRequest,
    lancamento: LancamentoRequest,
    formulario: FormularioRequest,
    organizacao: OrganizacaoRequest,
    prestacaoConta: PrestacaoContaRequest,
    pessoaAlcancada: PessoaAlcancadaRequest
};

export const RequestFactory = {
    get: name => requests[name]
};
